import HttpClient from "./HttpClient";
import axios from "axios";

export default class AxiosAdapter implements HttpClient {

	constructor() {
		axios.interceptors.request.use((config) => {
			let token = localStorage.getItem("token");
			if (!token) {
				token = new URL(location.href).searchParams.get('token');
				if (token) {
					localStorage.setItem("token", token);
					window.history.replaceState(null, null, window.location.pathname);
				}
			}
			config.headers["x-access-token"] = token;
			return config;
		}, (error) => {
			return Promise.reject(error);
		});
		axios.interceptors.response.use((response) => {
			return response;
		}, (error) => {
			const status = error.response.status;
			if (status === 401) {
				const currentUrl = window.location.href;
				window.location.href = `https://apps.gennera.com.br/public/#/login?url=${currentUrl}`;
				localStorage.removeItem("token");
			}
			return Promise.reject(error);
		});
	}

	async get(url: string) {
		const response = await axios({
			url,
			method: "get"
		});
		return response.data;
	}

	async post(url: string, body: any) {
		const response = await axios({
			url,
			method: "post",
			data: body
		});
		return response.data;
	}

	async put(url: string, body: any) {
		const response = await axios({
			url,
			method: "put",
			data: body
		});
		return response.data;
	}

	async delete(url: string) {
		const response = await axios({
			url,
			method: "delete"
		});
		return response.data;
	}
}
